import React from 'react';
import { Link } from 'react-router-dom';
import { Coins } from 'lucide-react';
import { useAuth } from '../../lib/AuthContext';

/**
 * PointsEarnLine — "Earn 5 pts per $1" incentive line.
 * Shown in the cart drawer + product pages. Nudges guests to create an
 * account so their Shopify purchase auto-earns rewards points.
 */
export const PointsEarnLine = ({ amount, className = '', testId = 'points-earn-line' }) => {
  const { user } = useAuth();
  const pts = Math.floor((amount || 0) * 5);
  if (pts <= 0) return null;
  const credit = (pts / 100).toFixed(2);

  return (
    <div
      className={`flex items-start gap-2 px-3 py-2 border border-[#C7FA3E]/20 bg-[#C7FA3E]/[0.04] ${className}`}
      data-testid={testId}
    >
      <Coins className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-[#C7FA3E]" />
      <p className="text-xs text-zinc-400 leading-snug">
        Earn <span className="text-[#C7FA3E] font-semibold">{pts.toLocaleString()} pts</span> on this purchase
        <span className="text-zinc-500"> (= ${credit} off future orders)</span>
        {!user && (
          <>
            {' — '}
            <Link to="/auth" className="text-white underline underline-offset-2 hover:text-[#C7FA3E] transition-colors" data-testid="points-earn-signup-link">
              create a free account
            </Link>{' '}
            with your checkout email to collect them.
          </>
        )}
      </p>
    </div>
  );
};
